"use client";

import { SectionHeaderFilter } from "@/components/SectionHeader";
import { useLogicalProductsManual } from "@/hooks/useLogicalProducts";
import { getSectionStyle } from "@/utils";
import { getPageRoute } from "@/utils/routes";
import { useEffect, useRef, useState } from "react";
import ProductRowSlider from "../ProductRowSlider";
import classes from "./FeaturedProducts.module.css";

const getKey = (index: number) => `tab-${index}`;

const FIRST_INDEX = 0;
const FilterProducts = ({
  widget,
  initialProducts,
}: {
  widget?: Widget;
  initialProducts?: ProductItem[];
}) => {
  const mainRef = useRef(null);
  const productLoading = useRef(false);

  const [selectedIndex, setSelectedIndex] = useState(FIRST_INDEX);
  const [logicalData, setLogicalData] = useState<LogicalProductItemsType>(
    widget?.data?.tabs?.[FIRST_INDEX]?.products || {}
  );

  // console.log("product widgets", widget);

  const [cachedData, setCachedData] = useState<{
    [key: string]: ProductItem[];
  }>({});

  const {
    products: _products,
    loading,
    error,
  } = useLogicalProductsManual({
    ...(logicalData as any),
    ref: mainRef,
    initialProducts,
    apiCallback(products) {
      productLoading.current = false;

      if (!products?.length) return;

      const key = getKey(selectedIndex);

      setCachedData((prev) => {
        if (prev[key]?.length) return prev;

        return {
          ...prev,
          [key]: products,
        };
      });
    },
  });

  const products = cachedData[getKey(selectedIndex)];

  const tabs = widget?.data?.tabs || [];

  const handleFilter = (index: number) => {
    const key = getKey(index);

    if (!cachedData[key]?.length) {
      setLogicalData(tabs[index]?.products || {});
      productLoading.current = true;
      setSelectedIndex(index);
      // setTimeout(() => setSelectedIndex(index), 200);
    } else {
      setSelectedIndex(index);
    }
  };

  const settings = widget?.data?.settings || {};

 

  return (
    <section
      className={classes.FeaturedProducts}
      ref={mainRef}
      style={getSectionStyle(settings)}
    >
      <SectionHeaderFilter
        filterItems={tabs}
        index={+(widget?.id || 0)}
        title={widget?.data?.title || ""}
        link={getPageRoute(
          tabs[selectedIndex]?.link?.urlType || "custom",
          tabs[selectedIndex]?.link?.url || ""
        )}
        btnText={tabs[selectedIndex]?.link?.hyperLinkText}
        filterIndex={selectedIndex}
        setFilterIndex={handleFilter}
        settings={widget?.data?.settings}
        key={widget?.id + "filterProducts"}
      />

      <div className="container">
        <ProductRowSlider
          key={widget?.id + "filterProducts"}
          products={products}
          loading={loading}
          animated={true}
          uid={"filter-" + widget?.id}
          settings={widget?.data?.settings}
        />
      </div>
    </section>
  );
};

export default FilterProducts;
